// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 297) return "static/chunks/297-be0767ab162215ed.js";
	if (chunkId === 720) return "static/chunks/720-7388010df8024ab7.js";
	if (chunkId === 848) return "static/chunks/848-1c0818a11e12cb6b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"130":"467db4cf2955f2a2","634":"229d9207ecaed8f8","704":"7e32dc591e84bd88","762":"cefdec6b97a5efc2"}[chunkId] + ".js";
};